// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  padding-top: 16em;
  padding-left: 1.5em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authentication/authentication.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;AACJ","sourcesContent":["h1 {\n    padding-top: 16em;\n    padding-left: 1.5em;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
